var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialInactiveIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38781",
    "data-name": "Group 38781",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12220",
    "data-name": "Rectangle 12220",
    width: 30,
    height: 30,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38771",
    "data-name": "Group 38771",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23105",
    "data-name": "Path 23105",
    d: "M15,5.77a2.308,2.308,0,1,1,2.308-2.308A2.311,2.311,0,0,1,15,5.77m0-3.462a1.154,1.154,0,1,0,1.154,1.154A1.155,1.155,0,0,0,15,2.308",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23106",
    "data-name": "Path 23106",
    d: "M15,28.847a2.308,2.308,0,1,1,2.308-2.308A2.311,2.311,0,0,1,15,28.847m0-3.462a1.154,1.154,0,1,0,1.154,1.154A1.155,1.155,0,0,0,15,25.385",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23107",
    "data-name": "Path 23107",
    d: "M23.654,9.231a2.308,2.308,0,1,1,2.308-2.308,2.311,2.311,0,0,1-2.308,2.308m0-3.462a1.154,1.154,0,1,0,1.154,1.154,1.155,1.155,0,0,0-1.154-1.154",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23108",
    "data-name": "Path 23108",
    d: "M26.538,17.308A2.308,2.308,0,1,1,28.846,15a2.311,2.311,0,0,1-2.308,2.308m0-3.462A1.154,1.154,0,1,0,27.692,15a1.155,1.155,0,0,0-1.154-1.154",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23109",
    "data-name": "Path 23109",
    d: "M23.654,25.385a2.308,2.308,0,1,1,2.308-2.308,2.311,2.311,0,0,1-2.308,2.308m0-3.462a1.154,1.154,0,1,0,1.154,1.154,1.155,1.155,0,0,0-1.154-1.154",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12212",
    "data-name": "Rectangle 12212",
    width: 1.154,
    height: 2.308,
    transform: "translate(14.423 5.192)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12213",
    "data-name": "Rectangle 12213",
    width: 1.154,
    height: 2.308,
    transform: "translate(14.423 22.5)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12214",
    "data-name": "Rectangle 12214",
    width: 2.448,
    height: 1.154,
    transform: "translate(20.361 9.4) rotate(-45)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12215",
    "data-name": "Rectangle 12215",
    width: 1.154,
    height: 2.448,
    transform: "translate(20.361 20.6) rotate(-45)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12216",
    "data-name": "Rectangle 12216",
    width: 2.308,
    height: 1.154,
    transform: "translate(22.5 14.423)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23110",
    "data-name": "Path 23110",
    d: "M6.346,9.231A2.308,2.308,0,1,1,8.654,6.923,2.311,2.311,0,0,1,6.346,9.231m0-3.462A1.154,1.154,0,1,0,7.5,6.923,1.155,1.155,0,0,0,6.346,5.769",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23111",
    "data-name": "Path 23111",
    d: "M3.461,17.308A2.308,2.308,0,1,1,5.769,15a2.311,2.311,0,0,1-2.308,2.308m0-3.462A1.154,1.154,0,1,0,4.615,15a1.155,1.155,0,0,0-1.154-1.154",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23112",
    "data-name": "Path 23112",
    d: "M6.346,25.385a2.308,2.308,0,1,1,2.308-2.308,2.311,2.311,0,0,1-2.308,2.308m0-3.462A1.154,1.154,0,1,0,7.5,23.077a1.155,1.155,0,0,0-1.154-1.154",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12217",
    "data-name": "Rectangle 12217",
    width: 1.154,
    height: 2.448,
    transform: "translate(7.092 8.485) rotate(-45)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12218",
    "data-name": "Rectangle 12218",
    width: 2.448,
    height: 1.154,
    transform: "translate(7.092 21.515) rotate(-45)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12219",
    "data-name": "Rectangle 12219",
    width: 2.308,
    height: 1.154,
    transform: "translate(5.192 14.423)",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23113",
    "data-name": "Path 23113",
    d: "M15,23.077A8.077,8.077,0,1,1,23.077,15,8.086,8.086,0,0,1,15,23.077m0-15A6.923,6.923,0,1,0,21.923,15,6.931,6.931,0,0,0,15,8.077",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23114",
    "data-name": "Path 23114",
    d: "M18.118,19.615H13.846a2,2,0,0,1-1.385-.443.434.434,0,0,0-.345-.134H10.385a.577.577,0,0,1-.577-.577V13.269a.577.577,0,0,1,.577-.577H11.95c.362-.083,1.9-1.4,1.9-2.308V9.807a.84.84,0,0,1,.435-.726,1.6,1.6,0,0,1,1.547.1A2.537,2.537,0,0,1,17,11.563a6.443,6.443,0,0,1-.216,1.516c-.023.1-.043.172-.05.222l0,.545a4.063,4.063,0,0,1-1.986,3.363l-.643-.958a2.965,2.965,0,0,0,1.475-2.4v-.577a2.08,2.08,0,0,1,.08-.46,5.377,5.377,0,0,0,.184-1.247,1.578,1.578,0,0,0-.519-1.334A.79.79,0,0,0,15,10.089v.3c0,1.614-2.164,3.462-3.05,3.462h-.988v4.038h1.154a1.541,1.541,0,0,1,1.044.37.892.892,0,0,0,.686.207h4.272a.456.456,0,0,0,.267-.265.535.535,0,0,1,.008-.089l.563-3.42a.759.759,0,0,0-.174-.605.635.635,0,0,0-.478-.236h-1V12.692h1a1.783,1.783,0,0,1,1.358.644,1.9,1.9,0,0,1,.432,1.54l-.557,3.381a1.519,1.519,0,0,1-1.419,1.358",
    fill: "#010101"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInactiveIcon);
export default __webpack_public_path__ + "static/media/social-inactive-icon.8c6280bfc4489f721d7a1ad2a24c1f16.svg";
export { ForwardRef as ReactComponent };